export interface valrops {
  text: JSX.Element
  color: string | undefined
}

export function DisplayValue(kind: string, data: any): valrops | undefined {
  if (!data?.val_p) return undefined
  switch(kind) {
    case "ddt":
      return {
        text: (
        <>
            {data?.val_p}
            {data?.diff_p !== 0 ? (
                data?.diff_p > 0 ? (
                  <>&#11014;</>
                ) : (
                  <>&#11015;</>
                )
            ) : ""}
        </>
      ),
      color: data?.diff_p !== 0 ? (
          data?.diff_p > 0 ? "#006400" : "red"
      ) : undefined
    }
    default:
      return undefined
  }
}
